import { AuthenticatedLayout } from "../../../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { RoleAssignmentSetup } from "../../../../components/RoleManagement/RolesAssignment/Setup";

export const RolesAssignmentSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Role Assignment Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<RoleAssignmentSetup />}
    />
  );
};
